const data = [
    {
        id: "1",
        listItem: "All participants should be undergraduates of a University or a Higher Education Institute"
    },
    {
        id: "2",
        listItem: "A team should consist of 3 to 5 members representing the same University or Institute."
    },
    {
        id: "3",
        listItem: "The ideas should be original and innovative. "
    },
    {
        id: "4",
        listItem: "Ideas should be presented in a proposal that adheres to the proposal format and guidelines provided."
    },
    {
        id: "5",
        listItem: "The proposed idea cannot be changed after the submission of the proposal, but the final product may consist of additional features."
    },
]

export default data;